/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { SubmissionStatus } from './SubmissionStatus';
import {
    SubmissionStatusFromJSON,
    SubmissionStatusFromJSONTyped,
    SubmissionStatusToJSON,
    SubmissionStatusToJSONTyped,
} from './SubmissionStatus';
import type { SubmissionChannel } from './SubmissionChannel';
import {
    SubmissionChannelFromJSON,
    SubmissionChannelFromJSONTyped,
    SubmissionChannelToJSON,
    SubmissionChannelToJSONTyped,
} from './SubmissionChannel';

/**
 * 
 * @export
 * @interface SubmissionListRequest
 */
export interface SubmissionListRequest {
    /**
     * 
     */
    statuses?: Array<SubmissionStatus> | null;
    /**
     * 
     */
    channels?: Array<SubmissionChannel> | null;
    /**
     * 
     */
    fromNumbers?: Array<string> | null;
    /**
     * 
     */
    species?: Array<string> | null;
    /**
     * 
     */
    hasFeedback?: boolean | null;
    /**
     * 
     */
    start?: Date | null;
    /**
     * 
     */
    end?: Date | null;
    /**
     * 
     */
    limit?: number;
    /**
     * 
     */
    before?: Date | null;
}

/**
 * Check if a given object implements the SubmissionListRequest interface.
 */
export function instanceOfSubmissionListRequest(value: object): value is SubmissionListRequest {
    return true;
}

export function SubmissionListRequestFromJSON(json: any): SubmissionListRequest {
    return SubmissionListRequestFromJSONTyped(json, false);
}

export function SubmissionListRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubmissionListRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'statuses': json['statuses'] === undefined ? undefined : json['statuses'] === null ? null : ((json['statuses'] as Array<any>).map(SubmissionStatusFromJSON)),
        'channels': json['channels'] === undefined ? undefined : json['channels'] === null ? null : ((json['channels'] as Array<any>).map(SubmissionChannelFromJSON)),
        'fromNumbers': json['from_numbers'] === undefined ? undefined : json['from_numbers'] === null ? null : json['from_numbers'],
        'species': json['species'] === undefined ? undefined : json['species'] === null ? null : json['species'],
        'hasFeedback': json['has_feedback'] === undefined ? undefined : json['has_feedback'] === null ? null : json['has_feedback'],
        'start': json['start'] === undefined ? undefined : json['start'] === null ? null : (parseDateTime(json['start'])),
        'end': json['end'] === undefined ? undefined : json['end'] === null ? null : (parseDateTime(json['end'])),
        'limit': json['limit'] == null ? undefined : json['limit'],
        'before': json['before'] === undefined ? undefined : json['before'] === null ? null : (parseDateTime(json['before'])),
    };
}

export function SubmissionListRequestToJSON(json: any): SubmissionListRequest {
    return SubmissionListRequestToJSONTyped(json, false);
}

export function SubmissionListRequestToJSONTyped(value?: SubmissionListRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'statuses': value['statuses'] == null ? undefined : ((value['statuses'] as Array<any>).map(SubmissionStatusToJSON)),
        'channels': value['channels'] == null ? undefined : ((value['channels'] as Array<any>).map(SubmissionChannelToJSON)),
        'from_numbers': value['fromNumbers'],
        'species': value['species'],
        'has_feedback': value['hasFeedback'],
        'start': value['start'] == null ? value['start'] : serializeDateTime(value['start']),
        'end': value['end'] == null ? value['end'] : serializeDateTime(value['end']),
        'limit': value['limit'],
        'before': value['before'] == null ? value['before'] : serializeDateTime(value['before']),
    };
}

